import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getMetiundoColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Name", accessorKey: "parameters.name", minSize: 150 },
    {
      header: "Seriennummer",
      accessorKey: "parameters.serialNumber",
      minSize: 160
    },
    { header: "Medium", accessorKey: "parameters.medium", size: 100 },
    { header: "MeLo", accessorKey: "parameters.melo", minSize: 170 },
    {
      header: "MaLo (Entnahme)",
      accessorKey: "parameters.maloConsumption",
      minSize: 150
    },
    {
      header: "MaLo (Einspeisung)",
      accessorKey: "parameters.maloProduction",
      minSize: 150
    }
  ];
}

export { getMetiundoColumns };
